import React, { useState } from 'react';

const TeamLogo = ({ logo, team, isWinner }) => {
  const [imageError, setImageError] = useState(false);
  const logoPath = logo.split('/').slice(-3).join('/');
  const newLogoUrl = `https://a.espncdn.com/combiner/i?img=/i/teamlogos/nfl/500/scoreboard/${logoPath.split('/').pop()}&scale=crop&cquality=100&location=origin&w=96&h=96`;

  return (
    <div className="relative flex items-center justify-center">
      <div className={`relative w-12 h-12 rounded-xl overflow-hidden shadow-lg border ${
        isWinner
          ? 'border-accent/50 shadow-accent/20'
          : 'border-border shadow-md'
      } bg-card transition-[border-color,box-shadow] duration-base ease-out`}>
        {!imageError ? (
          <img
            src={newLogoUrl}
            alt={`${team} logo`}
            className="w-full h-full object-cover"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-primary to-primary/60 flex items-center justify-center">
            <span className="text-primary-foreground font-bold text-xs">
              {team.substring(0, 3).toUpperCase()}
            </span>
          </div>
        )}
      </div>

      {isWinner && (
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-accent rounded-full flex items-center justify-center">
          <span className="text-accent-foreground text-xs font-bold">W</span>
        </div>
      )}
    </div>
  );
};

export default TeamLogo;
